module.exports = __webpack_public_path__ + "pigmentace_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/pigmentace_1_after.jpg
// module id = 969
// module chunks = 0